import { render, staticRenderFns } from "./leftSelect.vue?vue&type=template&id=4b0adc6b&scoped=true"
import script from "./leftSelect.vue?vue&type=script&lang=js"
export * from "./leftSelect.vue?vue&type=script&lang=js"
import style0 from "./leftSelect.vue?vue&type=style&index=0&id=4b0adc6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0adc6b",
  null
  
)

export default component.exports